import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#C2CC08",
        // secondary: "#165770"
        //  primary: "#c3cd08",
        secondary: "#16586f",
        // tertiary: "#165770",
      },
    },
  },
});
